<template>
	<div id="cesiumFullContainer" class="fill-parent-height">
		<b-row>
			<b-col cols="12">
				<div class="info-row">
                    <div class="info-col">
                        <div class="info-title">{{ displayValues.speed | units('m/s','knot',true) | truncate(2) }}</div>
                        <div class="info-number">{{ $t('global.speed') }}</div>
                    </div>
                    <div class="info-col">
                        <div class="info-title">{{ displayValues.distance | units('m','km',true) | truncate(2) }}</div>
                        <div class="info-number">{{ $t('global.distance') }}</div>
                    </div>
                    <div class="info-col">
                        <div class="info-title">{{ displayValues.heading | units('deg','deg',true) | truncate(0) }}</div>
                        <div class="info-number">{{ $t('global.angles.heading') }}</div>
                    </div>
					<div class="info-col">
                        <div class="info-title">{{ displayValues.pitch | units('rad','deg',true) | truncate(1) }}</div>
                        <div class="info-number">{{ $t('global.angles.pitch') }}</div>
                    </div>
					<div class="info-col">
                        <div class="info-title">{{ displayValues.roll | units('rad','deg',true) | truncate(1)}}</div>
                        <div class="info-number">{{ $t('global.angles.roll') }}</div>
                    </div>
                </div>
			</b-col>
		</b-row>
		<div class="fill-parent-height" id="cesiumContainer">
		</div>
		<div id="cesium-credit" style="display:none;" />	
	</div>
</template>

<script>

import * as Cesium from "cesium/Cesium";
import "cesium/Widgets/widgets.css";


const greenToRed = require('green-to-red');

export default {
	name: "EarthMap",
	data: function () {
		return {
			viewer: null,
			viewerOpts: {
				animation: true,
				timeline: true,
				geocoder: false,
				fullscreenButton: true,
				fullscreenElement:'cesiumFullContainer',
				sceneModePicker: false,
				navigationHelpButton: true,
				homeButton: false,
				baseLayerPicker: false,
				navigationInstructionsInitiallyVisible: false,
				creditContainer: "cesium-credit",
				contextOptions: {
					webgl:{
						preserveDrawingBuffer:true
					}
				}
			},
			displayValues: {
				date : "-",
				speed : "-",
				distance: 0,
				heading:"-",
				pitch:"-",
				roll:"-"
			}
		};
	},
	props:['trackPath','tsPath','motionData','sport','windDirection'],
	components: {
	},
	computed: {
	},
	watch: {
        trackPath: function(newPath,OldPath){
			// console.log("Watch path");
			// console.log(newPath);
        },
		markersArray() {
			this.updateMarkers();
		},
		pathsArray() {
			this.updatePolylines();
		},
		modelsArray() {
			this.updateModels();
		},
	},
	mounted() {
		console.group("Earth map mounted");

		Cesium.Ion.defaultAccessToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI1YTgyMWViOS03MjRiLTRjOGMtYTA2OS04YTVjNzBlMWUzMWYiLCJpZCI6MjM3MzksInNjb3BlcyI6WyJhc3IiLCJnYyJdLCJpYXQiOjE1ODM5MjYyOTd9.rkHsMeDwan5kS83j4Bo99zPupmUgUrOql4UFCX3nGSA";

		this.viewer = new Cesium.Viewer("cesiumContainer", this.viewerOpts);
		// Debug inspector
		// this.viewer.extend(Cesium.viewerCesiumInspectorMixin);

		// switch to request Render mode
		this.viewer.scene.requestRenderMode = true;
		// In play mode max scene time between two update
		this.viewer.scene.maximumRenderTimeChange = 0.1;

		// TODO : utiliser le switch debug / Prod
		if(process.env.NODE_ENV !== 'production'){
			this.viewer.scene.debugShowFramesPerSecond = true;
		}
		
		// Timer ticks
		this.viewer.clock.onTick.addEventListener(this.clockTick);

		// Init view
		if(this.trackPath != null && this.trackPath.length > 0){
			this.updatePolylines();
			this.updateModel();
			this.goTo({
				latitude:this.trackPath[0][0],
				longitude:this.trackPath[0][1]
			});
		}

		console.groupEnd();
	},
	methods: {
		async goTo(location) {
			this.viewer.camera.flyTo({
				destination: Cesium.Cartesian3.fromDegrees(
					location.longitude,
					location.latitude,
					2000.0
				),
			});
		},
		async updateMarkers() {
			console.group("Update map markers (" + this.markersArray.length + ")");

			if (this.mapMarkerCollection == null) {
				// console.log("Create a new marker collection");
				this.mapMarkerCollection = new Cesium.EntityCollection();
			} else {
				// console.log("Remove previous markers from entities");
				let viewerEntites = this.viewer.entities;
				this.mapMarkerCollection.values.forEach((mapMarker) => {
					if (viewerEntites.contains(mapMarker)) {
						viewerEntites.remove(mapMarker);
					} else {
						// console.log("Marker " + mapMarker.id + " not found");
					}
				});
				this.mapMarkerCollection.removeAll();
			}

			let pinBuilder = new Cesium.PinBuilder();

			this.markersArray.forEach(async (marker) => {
				let stationPin = await pinBuilder.fromMakiIconId(
					"skiing",
					Cesium.Color.CADETBLUE,
					50
				);

				let newMapMarker = new Cesium.Entity({
					name: marker.id,
					position: Cesium.Cartesian3.fromDegrees(
						marker.point.longitude,
						marker.point.latitude
					),
					billboard: {
						image: stationPin.toDataURL(),
						verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
						heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
					},
					ellipsoid: {
						radii: new Cesium.Cartesian3(200000.0, 200000.0, 200000.0),
						maximumCone: Cesium.Math.PI_OVER_TWO,
						material: Cesium.Color.BLUE.withAlpha(0.3),
						outline: true,
					},
					ellipse: {
						semiMinorAxis: 15.0,
						semiMajorAxis: 15.0,
						material: Cesium.Color.GREEN.withAlpha(0.5),
					},
				});

				this.viewer.entities.add(newMapMarker);
				this.mapMarkerCollection.add(newMapMarker);
			});

			this.viewer.scene.requestRender();

			console.groupEnd();
		},
		async updatePolylines() {
			try {
				//this.viewer.scene.primitives.removeAll();
				// loop over path array
				var trackPoints = [];
				var pointsColor = [];
				
				// console.log("Line " + path.id + " (" + path.points.length + ")");

				const speeds = this.trackPath.map(pt => pt[2]);
				const minSpeed = Math.min(...speeds);
				const maxSpeed = Math.max(...speeds);
				// console.log("Min : "+minSpeed+" max : "+maxSpeed);

				// loop over path points
				this.trackPath.forEach((point) => {
					if ( point.length != 3) {
						return;
					}
					let trackPoint = Cesium.Cartesian3.fromDegrees(Number(point[1]),Number(point[0]));
					trackPoints.push(trackPoint);

					// Color
					const colorRatio = 100 - ( (point[2] - minSpeed)/(maxSpeed - minSpeed) * 100 );
					pointsColor.push(Cesium.Color.fromCssColorString(greenToRed(colorRatio,true)));
				});

				var primitive = new Cesium.Primitive({
					geometryInstances: new Cesium.GeometryInstance({
						geometry: new Cesium.PolylineGeometry({
							positions: trackPoints,
							width: 2.0,
							vertexFormat: Cesium.PolylineColorAppearance.VERTEX_FORMAT,
							colors: pointsColor,
							colorsPerVertex: false,
						}),
					}),
					appearance: new Cesium.PolylineColorAppearance({
						translucent: false,
					}),
				});
				this.viewer.scene.primitives.add(primitive);


				// Request render
				this.viewer.scene.requestRender();
			} catch (e) {
				console.error(e.message);
			}

		},
		async updateModel(){
			// Start date
			const startDate = this.motionData[0].date;
			const start = Cesium.JulianDate.fromIso8601(startDate);
			// Stop date
			const stopDate = this.motionData[this.motionData.length - 1].date;
			const stop = Cesium.JulianDate.fromIso8601(stopDate);

			// Legend
			const speeds = this.motionData.map(pt => pt.speed);
			const minSpeed = Math.min(...speeds);
			const maxSpeed = Math.max(...speeds);

			// Motion properties
			const positionProperty = new Cesium.SampledPositionProperty();
			const orientationProperty = new Cesium.SampledProperty(Cesium.Quaternion);
			const wingOrientationProperty = new Cesium.SampledProperty(Cesium.Quaternion);
			const colorProperty = new Cesium.SampledProperty(Cesium.Color);
	
			// Loop on motion points
			for (let i = 0; i < this.motionData.length; i++) {
				const dataPoint = this.motionData[i];

				const date = Cesium.JulianDate.fromIso8601(dataPoint.date);
				const position = Cesium.Cartesian3.fromDegrees(dataPoint.longitude,dataPoint.latitude,dataPoint.altitude);

				// Fill position property
				positionProperty.addSample(date, position);

				// Fill atitude property
				// TODO : Check if we can remove -PI/2
				var heading = Cesium.Math.toRadians(dataPoint.bearing) - (Math.PI/2);
				var pitch = dataPoint.pitch;
				var roll = -dataPoint.roll;
				var hpr = new Cesium.HeadingPitchRoll(heading, pitch, roll);
				var orientation = Cesium.Transforms.headingPitchRollQuaternion(position,hpr);

				orientationProperty.addSample(date,orientation);

				var whpr = new Cesium.HeadingPitchRoll(Cesium.Math.toRadians(this.windDirection), 0, 0);
				var worientation = Cesium.Transforms.headingPitchRollQuaternion(position,whpr);
				wingOrientationProperty.addSample(date,worientation);

				// Fill color property
				const colorRatio = 100 - ( (dataPoint.speed - minSpeed)/(maxSpeed - minSpeed) * 100 );
				const colorPoint = Cesium.Color.fromCssColorString(greenToRed(colorRatio,true));
				colorProperty.addSample(date,colorPoint);
			}

			// 3D Model data source
			var dataSource = new Cesium.CustomDataSource('3D Model');

			// Entity
			let modelEntity = new Cesium.Entity();
			modelEntity.availability = new Cesium.TimeIntervalCollection([
				new Cesium.TimeInterval({ start: start, stop: stop })
			]);
			modelEntity.position = positionProperty;
			modelEntity.timeSeries = positionProperty;
			modelEntity.orientation = orientationProperty;

			// modelEntity.path = new Cesium.PathGraphics({
			// 	with:4.0,
			// 	// trailTime:10.0
			// 	leadTime:1.0,
			// 	material:new Cesium.ColorMaterialProperty(colorProperty)
			// });

			switch(this.sport){
				case "WINDFOIL":
					modelEntity.model = {
						uri: "https://spomo-models.s3.eu-west-3.amazonaws.com/windfoil/iqfoil.gltf",
						scale: 10	// IQFoil
					}; 
					dataSource.entities.add(modelEntity);
					break;
				case "WINDSURF":
					modelEntity.model = {
						uri: "https://spomo-models.s3.eu-west-3.amazonaws.com/windsurf/windsurf.glb",
						scale: 5	// IQFoil
					}; 
					dataSource.entities.add(modelEntity);
					break;
				case "KITEFOIL":
					modelEntity.model = {
						uri: "https://spomo-models.s3.eu-west-3.amazonaws.com/kitefoil/KiteSurf_board.glb",
						scale: 1	
					}; 
					dataSource.entities.add(modelEntity);

					let wingEntity = new Cesium.Entity();
					wingEntity.availability = new Cesium.TimeIntervalCollection([
						new Cesium.TimeInterval({ start: start, stop: stop })
					]);
					wingEntity.position = positionProperty;
					wingEntity.timeSeries = positionProperty;
					wingEntity.orientation = wingOrientationProperty;

					wingEntity.model = {
						uri: "https://spomo-models.s3.eu-west-3.amazonaws.com/kitefoil/KiteSurf_Kite.glb",
						scale: 1	
					}; 
					dataSource.entities.add(wingEntity);
					break;
				case "KITESURF":
					modelEntity.model = {
						uri: "https://spomo-models.s3.eu-west-3.amazonaws.com/kitesurf/SpomoTwinTip.glb",
						scale: 1	
					}; 
					dataSource.entities.add(modelEntity);

					let wingEntityKite = new Cesium.Entity();
					wingEntityKite.availability = new Cesium.TimeIntervalCollection([
						new Cesium.TimeInterval({ start: start, stop: stop })
					]);
					wingEntityKite.position = positionProperty;
					wingEntityKite.timeSeries = positionProperty;
					wingEntityKite.orientation = wingOrientationProperty;

					wingEntityKite.model = {
						uri: "https://spomo-models.s3.eu-west-3.amazonaws.com/kitesurf/SpomoKiteWing.glb",
						scale: 1
					}; 

					dataSource.entities.add(wingEntityKite);
					break;
				case "KARTING":
					modelEntity.model = {
						uri: "https://spomo-models.s3.eu-west-3.amazonaws.com/karting/RT10_2021.glb",
						scale: 1/64,	// Karting
					}; 
					dataSource.entities.add(modelEntity);
					break;
				default:
					modelEntity.model = {
						uri: "https://spomo-models.s3.eu-west-3.amazonaws.com/default/AxisFrame.glb",
					}; 
					dataSource.entities.add(modelEntity);
					break;
			}


			// this.viewer.entities.add(modelEntity);
			this.viewer.dataSources.add(dataSource);

			// Set timeline 
			this.setTimeLine(start,stop);
		},
		async updateModels() {
			console.group("updateModels (" + this.modelsArray.length + ")");

			if (this.mapModelCollection == null) {
				this.mapModelCollection = new Cesium.EntityCollection();
				this.clampedModels = new Cesium.EntityCollection();
			} else {
				this.mapModelCollection.values.forEach((model) => {
					if (this.viewer.entities.contains(model)) {
						this.viewer.entities.remove(model);
					}
				});
				this.mapModelCollection.removeAll();
				this.clampedModels.removeAll();
			}

			try {
				const startDate = this.modelsArray[0].points[0].date;
				const start = Cesium.JulianDate.fromIso8601(startDate);
				const stopDate = this.modelsArray[0].points[
					this.modelsArray[0].points.length - 1
				].date;
				const stop = Cesium.JulianDate.fromIso8601(stopDate);

				this.modelsArray.forEach((model) => {
					const positionProperty = new Cesium.SampledPositionProperty();
					const orientationProperty = new Cesium.SampledProperty(
						Cesium.Quaternion
					);
					const polylinePoints = [];
					const polylineColors = [];
					for (let i = 0; i < model.points.length; i++) {
						const dataPoint = model.points[i];

						const date = Cesium.JulianDate.fromIso8601(
							//dataPoint.date
							model.points[i].date
						);
						const position = Cesium.Cartesian3.fromDegrees(
							dataPoint.longitude,
							dataPoint.latitude,
							dataPoint.altitude
						);

						positionProperty.addSample(date, position);
						polylinePoints.push(position);
						polylineColors.push(Cesium.Color.BLUE);

						//orientationProperty.addSample(date,Cesium.Quaternion.fromHeadingPitchRoll(new Cesium.HeadingPitchRoll.fromDegrees(0, 0, 0)));

						var heading = Cesium.Math.toRadians(dataPoint.bearing) - (Math.PI/2);
						var pitch = 0;// dataPoint.pitch;
						var roll = 0; //-dataPoint.roll;
						var hpr = new Cesium.HeadingPitchRoll(heading, pitch, roll);
						var orientation = Cesium.Transforms.headingPitchRollQuaternion(
							position,
							hpr
						);
						orientationProperty.addSample(date,orientation);
					}

					// Entity
					let modelEntity = new Cesium.Entity({
						label:{
							//text:model.id,
							scale:0.5,
							font: "48px Helvetica",
							fillColor: Cesium.Color.SKYBLUE,
							outlineColor: Cesium.Color.BLACK,
							outlineWidth: 2,
							style: Cesium.LabelStyle.FILL_AND_OUTLINE,
							verticalOrigin:Cesium.VerticalOrigin.TOP
						}
					});
					modelEntity.availability = new Cesium.TimeIntervalCollection([
						new Cesium.TimeInterval({ start: start, stop: stop }),
					]);
					modelEntity.position = positionProperty;
					modelEntity.timeSeries = positionProperty;
					modelEntity.orientation = orientationProperty;

					modelEntity.model = {
						// uri: "http://localhost:8080/models/moto/MotoGP_Ducati.glb",
						uri: "http://localhost:8080/models/karting/RT10_2021.glb",
						// uri: "http://localhost:8080/models/windfoil/windfoil.gltf",
						// uri: "http://localhost:8080/models/windfoil/iqfoil.gltf",
						// uri: "http://localhost:8080/models/windfoil/AxisFrame.glb",
						heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
						// scale: 4,	// Windfoil
						scale: 1/64,	// Karting
						//minimumPixelSize : 128,
						//maximumScale : 100
					}; 

					this.viewer.entities.add(modelEntity);
					this.mapModelCollection.add(modelEntity);
					this.clampedModels.add(modelEntity);
				});

				this.viewer.clock.startTime = start.clone();
				this.viewer.clock.stopTime = stop.clone();
				this.viewer.clock.currentTime = start.clone();
				this.viewer.timeline.zoomTo(start, stop);
				// Speed up the playback speed 50x.
				this.viewer.clock.multiplier = 1;
				this.viewer.clock.onTick.addEventListener(this.clockTick);
				// Start playing the scene.
				//this.viewer.clock.shouldAnimate = true;
				this.isRunning = true;
			} catch (error) {
				console.error(error);
			} finally {
				console.groupEnd();
			}
		},
		setTimeLine(startDate,stopDate){
			this.viewer.clock.startTime = startDate.clone();
			this.viewer.clock.stopTime = stopDate.clone();
			this.viewer.clock.currentTime = startDate.clone();
			this.viewer.timeline.zoomTo(startDate, stopDate);
			// Speed up the playback speed 50x.
			this.viewer.clock.multiplier = 1;
		},
		clockTick: function (clock) {
			// console.log('clockTick');
			//this.displayValues.date = clock.currentTime; //Cesium.JulianDate.toIso8601(clock.currentTime);
			if (this.motionData == null || this.motionData.length <= 0) {
				return;
			}

			// let movingModel = this.modelsArray[0];
			// TODO : Pas performant
			// let currentPt = this.motionData.find(
			// 	(pt) => pt.date > clock.currentTime
			// );

			// TODO : Pas performant
			let currentPt = null;
			let fullDistance = 0;
			for(let idx=0;idx<this.motionData.length;idx++){
				fullDistance += this.motionData[idx].length;
				if(this.motionData[idx].date > clock.currentTime){
					currentPt = this.motionData[idx];
					break;
				}
			}

			if (currentPt != null) {
				// const ptDate = new Date(currentPt.date);
				// this.displayValues.date = ptDate.getHours() + ":" + ptDate.getMinutes() + ":" + ptDate.getSeconds();
				this.displayValues.speed = currentPt.speed; // this.$units(currentPt.speed).from('m/s').to('knot').toFixed(2);
				this.displayValues.distance = fullDistance.toFixed(1);
				this.displayValues.heading = Number(currentPt.bearing).toFixed(0);
				this.displayValues.pitch = currentPt.pitch; // this.$units(currentPt.pitch).from('rad').to('deg').toFixed(2);
				this.displayValues.roll = currentPt.roll; // this.$units(currentPt.roll).from('rad').to('deg').toFixed(2);
			} 
			// else {
			// 	console.log("No point found");
			// }
		}
	}
};


</script>

<style>

	#cesiumFullContainer {
		background-color: white;
	}

</style>